import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Icon, Logo } from '@/components/foundations';
import { Stepper } from './Stepper';

export type OnboardingLayoutProps = {
  steps: string[];
  current: number;
  children: ReactNode;
  logoTo?: string;
};

/** Cadastro em duas colunas (`.ob`): passos à esquerda, formulário à direita. */
export function OnboardingLayout({ steps, current, children, logoTo = '/auth' }: OnboardingLayoutProps) {
  return (
    <div className="ob-page"><svg className="deco" viewBox="0 0 1568 1003" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
<g fill="#e9f0fc"><rect x="-200" y="560" width="420" height="420" rx="70" transform="rotate(45 10 770)" opacity=".8" /><rect x="1430" y="300" width="300" height="300" rx="80" transform="rotate(45 1580 450)" opacity=".8" /><rect x="1300" y="620" width="320" height="320" rx="70" transform="rotate(45 1460 780)" opacity=".5" /><rect x="40" y="980" width="260" height="260" rx="40" transform="rotate(45 170 1100)" opacity=".6" /></g>
<g fill="none" stroke="#dbe5f7"><path d="M1440 280C1520 220 1580 190 1600 160" /><path d="M1445 290 1600 450" /><path d="M0 940 130 810" /></g></svg>
      <div className="ob">
        <aside>
          <Link to={logoTo} aria-label="Lisboon"><Logo id="lg3" /></Link>
          <Stepper steps={steps} current={current} />
          <div className="helpl"><Icon name="help" /><a href="#">Precisa de ajuda?</a></div>
        </aside>
        <main>{children}</main>
      </div>
    </div>
  );
}
